import {
  Box,
  Alert,
  Card,
  Container,
  Grid,
  Typography,
  FormControl,
  Select,
  ListItemText,
  Menu,
  MenuItem,
  InputLabel,
  Checkbox,
  TableContainer,
  ButtonGroup,
  Button,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TablePagination
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Helmet } from 'react-helmet';
import ahcStatus from '../../../../models/ahcStatus';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import AhcMisToolbar from './AhcMisToolbar';
import moment from 'moment';
import goodalipi from 'src/plugins/goodalipi';
import axios from 'axios';
import DateRange from 'src/components/common/DateRange';

export class PhsInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slectedMonth: 1,
      // months: ['20-21', '21-22', 'April','May', 'June', 'July', 'August', 'September'],
      // years: ['20-21', '21-22'],
      tilesData: [
        {
          dataType: 'yearly',
          year: '20-21'
        },
        {
          dataType: 'yearly',
          year: '21-22'
        },
      ],
      months: ['April', 'May', 'June', 'July', 'August', 'September', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
      selectedMonth: 'April',
      columnsToShow: [
        'Name',
        'EmployeeId',
        'CorporateName',
        'AppointmentID',
        'OrderID',
        'Relationship',
        'Gender',
        'Age',
        'AppointmentDate',
        'Month',
        'EmailId',
        'ContactNo',
        'PackageName',
        'VisitType',
        'Location',
        'City',
        'State',
        'DCID',
        'DCName',
        'Cost'
      ],
      anchorEl: null,
      misData: [],
      totalCount: 0,
      page: 0,
      limit: 5,
      duration: [`01/01/${new Date().getFullYear()}`, new Date()],
      exportType: 'xlsx',
      loading: false,
      showSnack: false,
      snackMsg: 'File download failed!',
      snackType: 'error'
    };
  }

  downloadFile(url) {
    var link = document.createElement('a');
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadMisData(data) {
    this.setState({
      loading: false,
      showSnack: true,
      snackMsg: 'File downloaded in progress...',
      snackType: 'info'
    });
    let payload = {};
    if (data.dataType == 'monthly') {
      payload = {
        month: data.month,
        year: new Date().getFullYear(),
        dataType: data.dataType
      };
    } else {
      payload = {
        year: data.year,
        dataType: data.dataType
      };
    }

    _axios
      .post(
        '/ahc/phsfiles',
        {
          service: 1,
          ...payload
        },
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (
          response.data &&
          response.data.isSuccess &&
          response.data.preSignedUrl
        ) {
          this.downloadFile(response.data.preSignedUrl);
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File downloaded successfully!',
            snackType: 'success'
          });
        } else if (response.data && !response.data.isSuccess) {
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File download failed!',
            snackType: 'error'
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showSnack: true,
          snackMsg: error?.response?.data?.error ? error.response.data.error : 'File download failed!',
          snackType: 'error'
        });
      });
  }


  handlePageChange = async (event, newPage) => {
    await this.setState({ page: newPage });
    this.fetchMisData();
  };

  handleLimitChange = async (event) => {
    await this.setState({ limit: event.target.value });
    this.fetchMisData();
  };

  handleChange(data) {
    this.setState({ slectedMonth: data });
  }

  handleDateChange(data) {
    this.setState({ duration: data });
  }

  fetchMisData() {
    let d = this.state.duration;
    let payload = {
      startIndex: this.state.page * this.state.limit,
      pageSize: this.state.limit,
      startDate: d[0],
      endDate: d[1]
    };
    _axios
      .post('/ahc/misInvoicedData', payload, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        if (res.data.isSuccess) {
          this.setState({ misData: res.data.result });
          this.setState({ totalCount: res.data.totalCount });
        }
      })
      .catch((err) => {
        alert('Something went wrong. Please try again');
      });
  }

  tilesToShow(data) {
    let label = 'Financial Year ' + data.year;
    if (data.dataType == 'monthly') {
      label = data.month + '-' + data.year;
    }
    return (
      <Card
        sm={12}
        sx={{
          width: '100%',
          borderRadius: 4,
          mb: 2,
          p: 3,
          boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
        }}
      >
        <Grid sm={12} xs={12}>
          <h3>
            {label}
            <Button
              sx={{ px: 2 }}
              onClick={() => this.downloadMisData(data)}
              startIcon={<ExportIcon size="18" />}
              style={{ marginLeft: '60%' }}
            >
              Export
            </Button>
          </h3>
        </Grid>
      </Card>
    );
  }
  handleClose = async (item) => {
    this.setState({ anchorEl: null });
    if (item) {
      this.setState({ exportType: item.title });
    }
  };
  exportFile = async () => {
    this.setState({
      loading: false,
      showSnack: true,
      snackMsg: 'File downloaded in progress...',
      snackType: 'info'
    });
    let payload = {
      startDate: this.state.duration[0],
      endDate: this.state.duration[1],
      fileType: this.state.exportType
    }
    _axios
      .post('/ahc/misInvoicedData', payload, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        if (res.data && res.data.isSuccess && res.data.preSignedUrl) {
          this.downloadFile(res.data.preSignedUrl)
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File downloaded successfully!',
            snackType: 'success'
          });
        }
        else if (response.data && !response.data.isSuccess) {
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File download failed!',
            snackType: 'error'
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showSnack: true,
          snackMsg: 'File download failed!',
          snackType: 'error'
        });
      });
  }

  componentDidMount() {
    this.fetchMisData();
  }
  render() {
    const fileList = [
      {
        id: 'CSV',
        title: 'csv'
      },
      {
        id: 'XLSX',
        title: 'xlsx'
      }
    ];
    const open = Boolean(this.state.anchorEl);
    return (
      <>
        <Helmet>
          <title>AHC | MIS Data</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          {' '}
          <br />
          <Container maxWidth={false}>
            <Grid container>
              <Grid sm={12} xs={12}>
                {
                  Array.from(Array(3)).map((item, index) => {
                    const currentDate = new Date().getFullYear();
                    const tilesData = {
                        dataType : 'yearly',
                        year: currentDate - index
                    };
                    return this.tilesToShow(tilesData);
                  })
                }
                <Card
                  sm={12}
                  xs={12}
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 2,
                    // p: 3,
                    boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                  }}
                >
                  <FormControl

                    sx={{ m: 1, display: 'flex', flexDirection: 'row'}}
                    size="small"
                    variant="outlined"
                    required
                  >
                    <h4 style={{margin: '5px'}}>Please Select Month of Current FY to Get InvoicedData</h4>
                    <Select
                      sx={{width: '20%', ml: '20px'}}
                      required
                      value={this.state.selectedMonth}
                      onChange={(ev) => {
                        this.setState({ selectedMonth: ev.target.value });
                      }}
                      renderValue={(selected) => selected}
                      label="Location"
                    >
                      {
                        new Date().getMonth() - 3 ? 
                        this.state.months.slice(0, new Date().getMonth() - 3).map((val, idx) => (
                          <MenuItem
                            sx={{ py: 0 }}
                            value={val}
                            key={idx}
                            name={val}
                          >
                            <ListItemText primary={val} />
                          </MenuItem>
                        )) :
                        this.state.months.map((val, idx) => (
                          <MenuItem
                            sx={{ py: 0 }}
                            value={val}
                            key={idx}
                            name={val}
                          >
                            <ListItemText primary={val} />
                          </MenuItem>
                        ))
                      }
                    </Select>
                    <Button
              sx={{ px: 2 }}
              onClick={() => this.downloadMisData({ dataType: 'monthly', month: this.state.selectedMonth })}
              startIcon={<ExportIcon size="18" />}
              style={{ marginLeft: '30%' }}
            >
              Export
            </Button>
                  </FormControl>
                </Card>
              </Grid>
            </Grid>
            <Grid item container lg={12} xs={12}>
              <Card
                sx={{
                  width: '100%',
                  borderRadius: 4,
                  mb: 0,
                  boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                }}
              >
                <Grid
                  sx={{ margin: '10px', display: 'flex' }}
                  item
                  xs={12}
                  sm={12}
                >
                  <DateRange
                    noHelperText={true}
                    helperTextValue={'Subscription'}
                    boxsize="small"
                    onDateChange={(value) => {
                      this.handleDateChange(value);
                    }}
                  />
                  <Button
                    sx={{
                      width: '20%',
                      height: '5%',
                      boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                      backgroundColor: '#143a72',
                      color: 'white',
                      marginLeft: '10px'
                    }}
                    onClick={(e) => this.fetchMisData()}
                  >
                    Refresh
                  </Button>
                  <ButtonGroup
                    variant="text"
                    disabled={false}
                    sx={{
                      width: '180px',
                      boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                      borderRadius: 15,
                      height: '40px',
                      marginLeft: '20%'
                    }}
                  >
                    <Button
                      sx={{ px: 2 }}
                      onClick={() => this.exportFile(this.state.exportType)}
                      startIcon={<ExportIcon size="18" />}
                    >
                      Export
                    </Button>
                    <Button
                      onClick={(e) =>
                        this.setState({ anchorEl: e.currentTarget })
                      }
                      endIcon={<ArrowDropDownIcon />}
                    >
                      {this.state.exportType}
                    </Button>
                  </ButtonGroup>
                  <Menu
                    id="export-menu"
                    open={open}
                    anchorEl={this.state.anchorEl}
                    onClose={() => this.handleClose()}
                    MenuListProps={{
                      'aria-labelledby': 'exporttypeMenu'
                    }}
                  >
                    {fileList.map((menu) => (
                      <MenuItem
                        key={menu.id}
                        onClick={() => this.handleClose(menu)}
                      >
                        {menu.title}
                      </MenuItem>
                    ))}
                  </Menu>
                </Grid>
                <TableContainer>
                  <Table stickyHeader aria-label="MIS Data" id="employee-list">
                    <TableHead>
                      <TableRow>
                        {this.state.columnsToShow.map((item) => {
                          return <TableCell>{item}</TableCell>;
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.misData.map((e) => (
                        <TableRow>
                          <TableCell>
                            {e['EmployeeName'] ? e['EmployeeName'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['EmployeeID'] ? e['EmployeeID'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['CorporateName'] ? e['CorporateName'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['AppointmentID'] ? e['AppointmentID'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['OrderID'] ? e['OrderID'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['Relationship'] ? e['Relationship'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['Gender'] ? e['Gender'] : 'NA'}
                          </TableCell>
                          <TableCell>{e['Age'] ? e['Age'] : 'NA'}</TableCell>
                          <TableCell>
                            {e['AppointmentDate']
                              ? moment(e.AppointmentDate).format('DD-MM-YYYY')
                              : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['Month'] ? e['Month'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['EmailId'] ? e['EmailId'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['ContactNo'] ? e['ContactNo'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['PackageName'] ? e['PackageName'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['VisitType'] ? e['VisitType'] : 'NA'}
                          </TableCell>
                          <TableCell>
                            {e['Location'] ? e['Location'] : 'NA'}
                          </TableCell>
                          <TableCell>{e['City'] ? e['City'] : 'NA'}</TableCell>
                          <TableCell>
                            {e['State'] ? e['State'] : 'NA'}
                          </TableCell>
                          <TableCell>{e['DCID'] ? e['DCID'] : 'NA'}</TableCell>
                          <TableCell>
                            {e['DCName'] ? e['DCName'] : 'NA'}
                          </TableCell>
                          <TableCell>{e['Cost'] ? e['Cost'] : 'NA'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={this.state.totalCount}
                    onPageChange={this.handlePageChange}
                    onRowsPerPageChange={this.handleLimitChange}
                    page={this.state.page}
                    rowsPerPage={this.state.limit}
                    rowsPerPageOptions={[5, 10, 25]}
                  />
                </TableContainer>
              </Card>
            </Grid>
          </Container>
          <Snackbar
            open={this.state.showSnack}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            onClose={() => this.setState({ showSnack: false })}
            autoHideDuration={4000}
          >
            <Alert
              onClose={() => this.setState({ showSnack: false })}
              severity={this.state.snackType}
            >
              {this.state.snackMsg}
            </Alert>
          </Snackbar>
        </Box>
      </>
    );
  }
}

export default PhsInvoice;
